import * as moment from 'moment';

// inputタグのtypeで検索
export const getElementByType = (typeName: string): HTMLInputElement | undefined => {
  const inputs = document.getElementsByTagName('input');
  for (let i = 0; i < inputs.length; i++) {
    if (inputs[i].type === typeName) {
        return inputs[i];
    }
  }

  return undefined;
};

// イベントさせない
export const returnFalse = (): boolean => {
  return false;
};

export const JS_VOID: string = 'javascript: void(0);';

export const RETURN_FALSE: string = 'return false;';

// ログイン済みならメニュー表示、未ログインならログイン画面に遷移するページのURL.
export const LOGIN_URL: string = '/admin.html';

/**
 * Base64に変換.
 *
 * @export
 * @param {*} origin 元の値.
 * @returns {string} Base64の文字列.
 */
export const encodeBase64 = (origin: any): string => {
  const objJsonStr = JSON.stringify(origin);
  const objJsonB64 = Buffer.from(objJsonStr).toString('base64');
  return objJsonB64;
};

/**
 * Base64から戻す.
 *
 * @export
 * @param {string} encodedData Base64の文字列.
 * @returns {string} 元の値.
 */
export const decodeBase64 = (encodedData: string): string => {
  const moji = new Buffer(encodedData, 'base64').toString('utf-8', 0, encodedData.length);
  const objJsonStr = JSON.parse(moji);
  return objJsonStr;
};

/**
 * クエリ文字列を変換する.
 *
 * @export
 * @param {string} query
 * @returns
 */
export const parseQueryString = (query: string) => {
  let obj = Object.create(null);
  query.slice(query.indexOf('?') + 1, query.length).split('&').map(entry => {
    Object.assign(obj, {
      [entry.split('=')[0]]: entry.split('=')[1]
    });
  });
  return obj;
};

/**
 * Canvasの縦横サイズを0にしてメモリ解放する.
 *
 * @export
 * @param {((HTMLCanvasElement | null)[])} [refCharts=[]]
 * @returns
 */
export const memoryReleaseForCanvas = (refCharts: (HTMLCanvasElement | null)[] = []) => {
  // 縦横サイズを0にしてcanvasを開放する.
  for (let i = 0; i < refCharts.length; i++) {
    let chart = refCharts[i];
    if (chart !== null && typeof(chart) !== 'undefined') {
      // Get canvas context
      const context1 = chart.getContext('2d');
      if (context1 === null) {
        return;
      }

      context1.canvas.width = 0;
      context1.canvas.height = 0;
    }
  }
};

export const ageFromYmd = (ymd: string): number => {
  return Number(moment().diff(moment(ymd), 'years'));
};

export const calcAge = (birthDay: string): number => {
  const birthDate = new Date(birthDay);
  const toDay = new Date();
  const thisYearBirthday =
      new Date(toDay.getFullYear(), birthDate.getMonth(), birthDate.getDate());
  const age = toDay.getFullYear() - birthDate.getFullYear();

  return (toDay < thisYearBirthday) ? age - 1 : age;
};

export const exportCSV = (records: any) => {
  let data = records.map((record: any) => record.join(',')).join('\r\n');

  let bom  = new Uint8Array([0xEF, 0xBB, 0xBF]);
  let blob = new Blob([bom, data], {type: 'text/csv'});
  let url = (window.URL).createObjectURL(blob);
  let link = document.createElement('a');
  link.download = 'result.csv';
  link.href = url;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const exportCSVCustom = (records: any, filename: string) => {
  let data = records.map((record: any) => record.join(',')).join('\r\n');

  let bom  = new Uint8Array([0xEF, 0xBB, 0xBF]);
  let blob = new Blob([bom, data], {type: 'text/csv'});
  let url = (window.URL).createObjectURL(blob);
  let link = document.createElement('a');
  link.download = filename + '.csv';
  link.href = url;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const exportJSON2CSV = (records: any, filename: string, fields: any, unwind: any) => {
  let data;
  const { Parser } = require('json2csv');
  const json2csvParser = new Parser({ fields, flattern: true, unwind: unwind});
  try {
    data = json2csvParser.parse(records); 
  } catch (error) {
    console.log(error);
  }
  let bom  = new Uint8Array([0xEF, 0xBB, 0xBF]);
  let blob = new Blob([bom, data], {type: 'text/csv'});
  let url = (window.URL).createObjectURL(blob);
  let link = document.createElement('a');
  link.download = filename + '.csv';
  link.href = url;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const createFileJSON2CSV = (records: any, filename: string, fields: any, unwind: any): File => {
  let data;
  const { Parser } = require('json2csv');
  const json2csvParser = new Parser({ fields, flattern: true, unwind: unwind});
  try {
    data = json2csvParser.parse(records); 
  } catch (error) {
    console.log(error);
  }
  let bom  = new Uint8Array([0xEF, 0xBB, 0xBF]);
  let blob = new Blob([bom, data], {type: 'text/csv'});

  return new File([blob], filename + '.csv');
};

export const createBlobJSON2CSV = (records: any, filename: string, fields: any, unwind: any): Blob => {
  let data;
  const { Parser } = require('json2csv');
  const json2csvParser = new Parser({ fields, flattern: true, unwind: unwind});
  try {
    data = json2csvParser.parse(records); 
  } catch (error) {
    console.log(error);
  }
  let bom  = new Uint8Array([0xEF, 0xBB, 0xBF]);
  let blob = new Blob([bom, data], {type: 'text/csv'});

  return blob;
};

export const createBlobCSV = (records: any, filename: string): Blob => {
  let data = records.map((record: any) => record.join(',')).join('\r\n');
  let bom  = new Uint8Array([0xEF, 0xBB, 0xBF]);
  let blob = new Blob([bom, data], {type: 'text/csv'});
  return blob;
};


// WEBPACK FOOTER //
// ./src/utils/commonUtil.tsx